<template>
    <div class="pt-3 fill-height myprovet-shopping-cart-list" v-if="!isMobile && getCampaignItems.length>0" >
        <v-row class="d-flex align-center justify-space-between mx-0 mt-0 search-options" v-if="totalItems>5&& !isToShowOnlyOneProductCampaign">
            <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                <v-col cols="12" md="4" >
                    <v-text-field style="padding-top: 0;"
                        v-model="searchArticle"
                        append-icon="mdi-magnify"
                        :label="$t('campaigns.searchProduct')"
                        single-line
                        hide-details
                        clearable
                        @click:clear="updateCurrentPage"
                        @keyup="updateCurrentPage">
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="8" class="d-flex mx-0 mt-0 pt-0 show-products-radio">
                    <v-checkbox class="show-selected-products"
                        :disabled="isDisabledSelected"
                        @change="updateCurrentPage"
                        v-model="showSelected"
                        :label="'Ver produtos selecionados'">
                    </v-checkbox>
                </v-col>
            </v-col>
         </v-row>
        <v-row class="no-gutters px-4 mb-0">
            <v-col cols="12" :style="calculateHeaderColWidth('designation')">
                <div class="d-flex fill-height align-center justify-start">
                    <strong class="font-size-md dark-blue-color">{{ $t('campaigns.product') }}</strong>
                </div>
            </v-col>

            <v-col cols="12" :style="calculateHeaderColWidth('quantity')">
                <div class="d-flex fill-height align-center justify-center">
                    <strong class="font-size-md dark-blue-color">{{ $t('orders.base.quantity') }}</strong>
                </div>
            </v-col>

            <v-col cols="12" :style="calculateHeaderColWidth('bonus')">
                <div class="d-flex fill-height align-center justify-center">
                    <strong class="font-size-md dark-blue-color">{{ $t('orders.base.bonus') }}</strong>
                </div>
            </v-col>

            <v-col v-if="userStore.hasPermissionTo('View prices')" :style="calculateHeaderColWidth('price')">
                <div class="d-flex fill-height align-center justify-center">
                    <strong class="font-size-md dark-blue-color">{{ $t('campaigns.unitPrice') }}</strong>
                </div>
            </v-col>

            <v-col cols="12" :style="calculateHeaderColWidth('tax')">
                <div class="d-flex fill-height align-center justify-center">
                    <strong class="font-size-md dark-blue-color">{{ $t('orders.base.vat') }}</strong>
                </div>
            </v-col>

            <v-col v-if="userStore.hasPermissionTo('View prices')" :style="calculateHeaderColWidth('total')">
                <div class="d-flex fill-height align-center justify-center">
                    <strong class="font-size-md dark-blue-color">{{ $t('campaigns.value') }}</strong>
                </div>
            </v-col>
        </v-row>

        <v-list flat class="px-2 pt-0 myprovet-shopping-cart-list">
            <v-list-item-group :ripple="false">
                <template v-for="(item, index) in getCampaignItems">
                    <v-list-item data-cy="shopping-cart-item" :ripple="false" :key="item.uniqueId+'_'+index" v-if="checkIfToShowAllProducts(item)" class="px-0" style="cursor: default">
                        <div class="myprovet-list-item-row mr-0" style="height: 58px">
                            <div v-if="hasMultipleOptions && item.isOffer">
                                <v-radio-group :value="selectedOffer" hide-details class="py-0 pl-4">
                                    <v-radio :value="item.option" @change="selectOffer(item)"></v-radio>
                                </v-radio-group>
                            </div>

                            <div
                                :style="calculateColWidth('designation')"
                                :class="{
                                    'pl-4': !hasProductsToShow() && !hasMultipleOptions,
                                    'pl-12': item.isOffer && !item.isSeparate && !hasMultipleOptions,
                                    'pl-1': item.isOffer && hasMultipleOptions,
                                }"
                                class="myprovet-list-item-content"
                            >
                                <div class="d-flex fill-height align-center justify-start">
                                    <v-icon v-if="item.isOffer" class="appbar-icon-button-small btn-bg-color-dark-yellow white--text mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else-if="item.isHeader" class="appbar-icon-button-small btn-bg-color-yellow dark-yellow-color mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else class="appbar-icon-button-small btn-bg-color-grey grey-color mr-2" style="visibility: hidden">mdi-star-outline </v-icon>

                                    <v-list-item-content @click="openProductDetails(item)" class="py-0 myprovet-list-item-content-clickable">
                                        <p class="shopping-cart-product-title" data-cy="cart-item-designation" v-text="item.designation"></p>
                                        <v-list-item-subtitle v-if="item.code" style="font-size: 10px; margin-bottom: -4px; line-height: 1.5">{{ item.code }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateColWidth('quantity')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <quantity-counter
                                        v-if="!item.isOffer"
                                        :key="quantityCounterKey+'_q1_'+index"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        @input="onCampaignQuantityUpdated(item, $event)"
                                        @input-remove-campaign="tryRemoveCampaign(item)"
                                        @increment="changeCampaignQuantity(item, true)"
                                        @decrement="changeCampaignQuantity(item, false)"
                                        :hide-input="hideQuantityCounter(item)"
                                        :hide-counter="hideQuantityCounter(item) || branchStore.cannotPurchase"
                                        :disabled="item.exceeding_quantity || branchStore.cannotPurchase? true : false"
                                        class="justify-space-between mx-auto"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>

                                    <quantity-counter
                                        v-else-if="item.isOffer && item.exceeding_quantity"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        :disabled="true"
                                        :hide-counter="true"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateHeaderColWidth('bonus')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <p v-if="isBonusDiscount(item)" class="shopping-cart-product-title mt-5" data-cy="cart-item-discount-percentage">{{ item.discount }}%</p>

                                    <quantity-counter
                                        v-else
                                        :readonly="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :hide-counter="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :hide-input="!hideQuantityCounter(item)"
                                        :value="offerBonusQuantity(item,index)"
                                        :min="item.quantity > 0 ? 0 : 1"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>
                                </div>
                            </div>

                            <div v-if="userStore.hasPermissionTo('View prices')" class="myprovet-list-item-content" :style="calculateColWidth('price')">
                                <div class="d-flex fill-height align-center justify-end cart-dialog-price" style="width: fit-content">
                                    <template v-if="item.discount">
                                        <v-list-item-content class="py-0 shopping-cart-product-title text-center">
                                            <p class="red--text text-decoration-strikethrough" style="font-size: 0.75rem !important">{{ formatPrice(item.price) }}</p>
                                            <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem !important; margin-bottom: -4px; line-height: 1.5">{{ formatPrice(item.price - item.price * (item.discount / 100)) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else-if="item.value">
                                        <v-list-item-content class="py-0 shopping-cart-product-title text-center">
                                            <p class="red--text text-decoration-strikethrough" style="font-size: 0.75rem !important">{{ formatPrice(item.price) }}</p>
                                            <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem !important; margin-bottom: -4px; line-height: 1.5">{{ formatPrice(item.value) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else>
                                        <p class="shopping-cart-product-title mt-5" data-cy="cart-item-price">{{ formatPrice(item.price) }}</p>
                                    </template>

                                    <product-discounts-icon v-if="userStore.hasPermissionTo('View discounts icon')" :product="item"></product-discounts-icon>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateColWidth('tax')">
                                <div class="d-flex fill-height align-center justify-end">
                                    <p class="shopping-cart-product-title mt-5" data-cy="cart-item-tax">{{ item.vat.tax }} %</p>
                                </div>
                            </div>

                            <div v-if="userStore.hasPermissionTo('View prices')" class="myprovet-list-item-content" :style="calculateColWidth('total')">
                                <div class="d-flex fill-height align-center justify-end">
                                    <p class="shopping-cart-product-title mt-5" data-cy="cart-item-sub-total-price">{{ formatPrice(getProductSubTotalPrice(item)) }}</p>
                                </div>
                            </div>

                            <div class="pr-0 myprovet-list-item-content" :style="calculateColWidth('actions')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <div class="mr-0 myprovet-cart-item-button">
                                        <product-comment v-if="isActiveCampaign && item.quantity > 0" :product="item"></product-comment>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-list-item>
                </template>
            </v-list-item-group>
        </v-list>

         <v-list flat class="px-2 pt-0 myprovet-shopping-cart-list">
            <v-list-item-group :ripple="false">
                <template v-for="(item, index) in tempOffers">
                    <v-list-item data-cy="shopping-cart-item" :ripple="false" :key="item.uniqueId+'_offer1_'+index" v-if="totalItems>5&& item.isOffer && !isToShowOnlyOneProductCampaign" class="px-0" style="cursor: default">
                        <div class="myprovet-list-item-row mr-0" style="height: 58px">
                            <div v-if="hasMultipleOptions && item.isOffer">
                                <v-radio-group :value="selectedOffer" hide-details class="py-0 pl-4">
                                    <v-radio :value="item.option" @change="selectOffer(item)"></v-radio>
                                </v-radio-group>
                            </div>

                            <div
                                :style="calculateColWidth('designation')"
                                :class="{
                                    'pl-4': !hasProductsToShow() && !hasMultipleOptions,
                                    'pl-12': item.isOffer && !item.isSeparate && !hasMultipleOptions,
                                    'pl-1': item.isOffer && hasMultipleOptions,
                                }"
                                class="myprovet-list-item-content"
                            >
                                <div class="d-flex fill-height align-center justify-start">
                                    <v-icon v-if="item.isOffer" class="appbar-icon-button-small btn-bg-color-dark-yellow white--text mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else-if="item.isHeader" class="appbar-icon-button-small btn-bg-color-yellow dark-yellow-color mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else class="appbar-icon-button-small btn-bg-color-grey grey-color mr-2" style="visibility: hidden">mdi-star-outline </v-icon>

                                    <v-list-item-content @click="openProductDetails(item)" class="py-0 myprovet-list-item-content-clickable">
                                        <p class="shopping-cart-product-title" data-cy="cart-item-designation" v-text="item.designation"></p>
                                        <v-list-item-subtitle v-if="item.code" style="font-size: 10px; margin-bottom: -4px; line-height: 1.5">{{ item.code }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateColWidth('quantity')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <quantity-counter
                                        v-if="!item.isOffer"
                                        :key="quantityCounterKey+'_q2_'+index"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        @input="onCampaignQuantityUpdated(item, $event)"
                                        @input-remove-campaign="tryRemoveCampaign(item)"
                                        @increment="changeCampaignQuantity(item, true)"
                                        @decrement="changeCampaignQuantity(item, false)"
                                        :hide-input="hideQuantityCounter(item)"
                                        :hide-counter="hideQuantityCounter(item) || branchStore.cannotPurchase"
                                        :disabled="item.exceeding_quantity || branchStore.cannotPurchase? true : false"
                                        class="justify-space-between mx-auto"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>

                                    <quantity-counter
                                        v-else-if="item.isOffer && item.exceeding_quantity"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        :disabled="true"
                                        :hide-counter="true"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateHeaderColWidth('bonus')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <p v-if="isBonusDiscount(item)" class="shopping-cart-product-title mt-5" data-cy="cart-item-discount-percentage">{{ item.discount }}%</p>

                                    <quantity-counter
                                        v-else
                                        :readonly="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :hide-counter="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                        :hide-input="!hideQuantityCounter(item)"
                                        :value="offerBonusQuantity(item,index)"
                                        :min="item.quantity > 0 ? 0 : 1"
                                        input-class="shopping-cart-input minimum-input-size"
                                    ></quantity-counter>
                                </div>
                            </div>

                            <div v-if="userStore.hasPermissionTo('View prices')" class="myprovet-list-item-content" :style="calculateColWidth('price')">
                                <div class="d-flex fill-height align-center justify-end cart-dialog-price" style="width: fit-content">
                                    <template v-if="item.discount">
                                        <v-list-item-content class="py-0 shopping-cart-product-title text-center">
                                            <p class="red--text text-decoration-strikethrough" style="font-size: 0.75rem !important">{{ formatPrice(item.price) }}</p>
                                            <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem !important; margin-bottom: -4px; line-height: 1.5">{{ formatPrice(item.price - item.price * (item.discount / 100)) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else-if="item.value">
                                        <v-list-item-content class="py-0 shopping-cart-product-title text-center">
                                            <p class="red--text text-decoration-strikethrough" style="font-size: 0.75rem !important">{{ formatPrice(item.price) }}</p>
                                            <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem !important; margin-bottom: -4px; line-height: 1.5">{{ formatPrice(item.value) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>

                                    <template v-else>
                                        <p class="shopping-cart-product-title mt-5" data-cy="cart-item-price">{{ formatPrice(item.price) }}</p>
                                    </template>

                                    <product-discounts-icon v-if="userStore.hasPermissionTo('View discounts icon')" :product="item"></product-discounts-icon>
                                </div>
                            </div>

                            <div class="myprovet-list-item-content" :style="calculateColWidth('tax')">
                                <div class="d-flex fill-height align-center justify-end">
                                    <p class="shopping-cart-product-title mt-5" data-cy="cart-item-tax">{{ item.vat.tax }} %</p>
                                </div>
                            </div>

                            <div v-if="userStore.hasPermissionTo('View prices')" class="myprovet-list-item-content" :style="calculateColWidth('total')">
                                <div class="d-flex fill-height align-center justify-end">
                                    <p class="shopping-cart-product-title mt-5" data-cy="cart-item-sub-total-price">{{ formatPrice(getProductSubTotalPrice(item)) }}</p>
                                </div>
                            </div>

                            <div class="pr-0 myprovet-list-item-content" :style="calculateColWidth('actions')">
                                <div class="d-flex fill-height align-center justify-center">
                                    <div class="mr-0 myprovet-cart-item-button">
                                        <product-comment v-if="isActiveCampaign && item.quantity > 0" :product="item"></product-comment>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-list-item>
                </template>
            </v-list-item-group>
        </v-list>
        <div class="text-center" v-if="totalItems>5 && !isToShowOnlyOneProductCampaign">
                <v-pagination
                v-model="currentPage"
                :length="numberPages"
                :total-visible="7"
                ></v-pagination>
         </div>
    </div>
    <div class="pt-3 fill-height myprovet-shopping-cart-list campaign-shopping-cart" v-else>
        <v-row class="d-flex align-center justify-space-between mx-0 mt-0" v-if="totalItems>5 && !isToShowOnlyOneProductCampaign">
            <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                <v-text-field style="padding-top: 0;"
                    v-model="searchArticle"
                    append-icon="mdi-magnify"
                    :label="$t('campaigns.searchProduct')"
                    single-line
                    hide-details
                    clearable
                    @click:clear="updateCurrentPage"
                    @change="updateCurrentPage">
                </v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex mx-0 mt-0 pt-0 show-products-radio">
                <v-checkbox class="show-selected-products"
                    :disabled="isDisabledSelected"
                    @change="updateCurrentPage"
                    v-model="showSelected"
                    :label="'Ver produtos selecionados'">
                </v-checkbox>
            </v-col>
        </v-row>
    <div  v-for="(item, index) in getCampaignItems" :key="item.uniqueId" >
            <v-row v-if="checkIfToShowAllProducts(item)">
                <v-col class="d-flex flex-column col pt-0 pb-0 ">
                    <v-row class="d-flex align-start pt-0 pb-0">
                        <v-col class="col col-2 pt-0 pb-0 wrap-icon-campaign">
                            <div v-if="hasMultipleOptions && item.isOffer">
                                <v-radio-group :value="selectedOffer" hide-details class="py-0 pl-4">
                                    <v-radio :value="item.option" @change="selectOffer(item)"></v-radio>
                                </v-radio-group>
                            </div>
                            <div :style="calculateColWidth('designation')" :class="{
                                    'pl-4': !hasProductsToShow() && !hasMultipleOptions,
                                    'pl-12': item.isOffer && !item.isSeparate && !hasMultipleOptions,
                                    'pl-1': item.isOffer && hasMultipleOptions,
                                }" class="myprovet-list-item-content">
                                <div class="d-flex fill-height align-center justify-start">
                                    <v-icon v-if="item.isOffer" class="appbar-icon-button-small btn-bg-color-dark-yellow white--text mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else-if="item.isHeader" class="appbar-icon-button-small btn-bg-color-yellow dark-yellow-color mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else class="appbar-icon-button-small btn-bg-color-grey grey-color mr-2" style="visibility: hidden">mdi-star-outline </v-icon>
                                </div>
                            </div>
                        </v-col>
                        <v-col class="col col-10 pt-0 pb-0">
                            <v-row class="d-flex align-start pt-0 pb-0">
                                <v-col class="col col-12 pt-0 pb-0">
                                    <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item)">
                                        {{ item.designation }}
                                    </div>
                                </v-col>
                                <v-col class="col col-12 pt-0 pb-0">
                                    <div class="pl-0 datatable-lable-text laboratory">
                                        {{ item.code}}
                                    </div>
                                </v-col>
                                <v-col class="col col-12 pt-0 pb-0 stock">
                                    <div class="price">
                                        <template v-if="item.discount">
                                            <v-list-item-content class="py-0">
                                                <div class="flex-column" style="line-height: 18px">
                                                    <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.75rem">{{ formatPrice(item.price) }}</p>
                                                    <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem">{{ formatPrice(item.price - item.price * (item.discount / 100)) }}</v-list-item-subtitle>
                                                </div>
                                            </v-list-item-content>
                                        </template>

                                        <template v-else-if="item.value">
                                            <v-list-item-content class="py-0">
                                                <div class="flex-column" style="line-height: 18px">
                                                    <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.75em">{{ formatPrice(item.price) }}</p>
                                                    <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem">{{ formatPrice(item.value) }}</v-list-item-subtitle>
                                                </div>
                                            </v-list-item-content>
                                        </template>

                                        <template v-else>
                                            {{ formatPrice(item.price) }}
                                        </template>
                                    </div>
                                    <div class="btn-actions">
                                        <div class="mr-1 myprovet-cart-item-button">
                                            <v-tooltip v-if="index == 0 && isActiveCampaign" bottom open-on-hover content-class="myprovet-tooltip">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color" @click="forceRemoveCampaign(item)" v-on="on" v-bind="attrs" data-cy="remove-product"> mdi-delete-outline </v-icon>
                                                </template>

                                                <span>{{ $t('cart.removeCampaign') }}</span>
                                            </v-tooltip>
                                        </div>
                                        <div class="mr-1 myprovet-cart-item-button">
                                            <product-comment v-if="item.quantity > 0" :product="item"></product-comment>
                                        </div>

                                    </div>
                                    <!--<v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon style="" :color="isAvailable(product) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                    </template>

                                                                    <span>{{ isAvailable(product) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                                                </v-tooltip>
                                                                <product-additional-info :product="product"> </product-additional-info>-->
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                            <v-row :class="hideQuantityCounter(item)?'d-flex align-start pt-0 pb-0 no-label-qty':'d-flex align-start pt-0 pb-0 no-input-bonus'">
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-0 label" v-if="!hideQuantityCounter(item)">{{ $t('orders.base.quantity') }}</div>
                                    <quantity-counter v-if="!item.isOffer"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        @input="onCampaignQuantityUpdated(item, $event)"
                                        @input-remove-campaign="tryRemoveCampaign(item)"
                                        @increment="changeCampaignQuantity(item, true)"
                                        @decrement="changeCampaignQuantity(item, false)"
                                        :hide-input="hideQuantityCounter(item) || branchStore.cannotPurchase"
                                        :hide-counter="hideQuantityCounter(item)"
                                        :disabled="item.exceeding_quantity || branchStore.cannotPurchase? true : false"
                                        class="justify-space-between mx-auto"
                                        input-class="shopping-cart-input minimum-input-size">
                                    </quantity-counter>
                                    <quantity-counter v-else-if="item.isOffer && item.exceeding_quantity"
                                        :is-active-campaign="isActiveCampaign" :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        :disabled="true"
                                        :hide-counter="true"
                                        input-class="shopping-cart-input minimum-input-size">
                                   </quantity-counter>
                                </v-col>
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-2 empty"></div>
                                    <div class="col pt-0 pb-2  pl-0 pr-0 label lf">
                                        <div class="l-sub">{{ $t('orders.base.vat') }}</div>
                                        <div class="l-sub-value">{{item.vat.tax}} %</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                            <v-row :class="hideQuantityCounter(item)?'d-flex align-start pt-0 pb-0 no-input-qty':'d-flex align-start pt-0 pb-0 no-label-bn'">
                                <v-col class="col col-6 pt-0 pb-0 pl-0 wrap-bonus">
                                    <div class="col pt-0 pb-0 label" v-if="hideQuantityCounter(item)">{{ $t('orders.base.bonus') }}</div>
                                    <p v-if="isBonusDiscount(item)" class="shopping-cart-product-title mt-5" data-cy="cart-item-discount-percentage">{{ item.discount }}%</p>
                                    <quantity-counter v-else :readonly="item.campaign_id != null || !canChangeBonusQuantity"
                                    :hide-counter="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                    :hide-input="!hideQuantityCounter(item)"
                                    :disabled="branchStore.cannotPurchase"
                                    :value="offerBonusQuantity(item,index)"
                                    :min="item.quantity > 0 ? 0 : 1"
                                    input-class="shopping-cart-input minimum-input-size">
                                </quantity-counter>
                                </v-col>
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-2 empty"></div>
                                    <div class="col pt-0 pb-2  pl-0 pr-0 label lf ">
                                        <div class="l-sub">{{ $t('campaigns.value') }}</div>
                                        <div class="l-sub-value" v-if="userStore.hasPermissionTo('View prices')">

                                            <p class="shopping-cart-product-title " data-cy="cart-item-sub-total-price">{{ formatPrice(getProductSubTotalPrice(item)) }}</p>

                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>
                </v-col>
            </v-row>
    </div>
    <div  v-for="(item, index) in tempOffers" :key="item.uniqueId+'_offers_'+index" >
            <v-row v-if="totalItems>5&& item.isOffer && !isToShowOnlyOneProductCampaign">
                <v-col class="d-flex flex-column col pt-0 pb-0 ">
                    <v-row class="d-flex align-start pt-0 pb-0">
                        <v-col class="col col-2 pt-0 pb-0 wrap-icon-campaign">
                            <div v-if="hasMultipleOptions && item.isOffer">
                                <v-radio-group :value="selectedOffer" hide-details class="py-0 pl-4">
                                    <v-radio :value="item.option" @change="selectOffer(item)"></v-radio>
                                </v-radio-group>
                            </div>
                            <div :style="calculateColWidth('designation')" :class="{
                                    'pl-4': !hasProductsToShow() && !hasMultipleOptions,
                                    'pl-12': item.isOffer && !item.isSeparate && !hasMultipleOptions,
                                    'pl-1': item.isOffer && hasMultipleOptions,
                                }" class="myprovet-list-item-content">
                                <div class="d-flex fill-height align-center justify-start">
                                    <v-icon v-if="item.isOffer" class="appbar-icon-button-small btn-bg-color-dark-yellow white--text mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else-if="item.isHeader" class="appbar-icon-button-small btn-bg-color-yellow dark-yellow-color mr-2">mdi-star-outline </v-icon>
                                    <v-icon v-else class="appbar-icon-button-small btn-bg-color-grey grey-color mr-2" style="visibility: hidden">mdi-star-outline </v-icon>
                                </div>
                            </div>
                        </v-col>
                        <v-col class="col col-10 pt-0 pb-0">
                            <v-row class="d-flex align-start pt-0 pb-0">
                                <v-col class="col col-12 pt-0 pb-0">
                                    <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item)">
                                        {{ item.designation }}
                                    </div>
                                </v-col>
                                <v-col class="col col-12 pt-0 pb-0">
                                    <div class="pl-0 datatable-lable-text laboratory">
                                        {{ item.code}}
                                    </div>
                                </v-col>
                                <v-col class="col col-12 pt-0 pb-0 stock">
                                    <div class="price">
                                        <template v-if="item.discount">
                                            <v-list-item-content class="py-0">
                                                <div class="flex-column" style="line-height: 18px">
                                                    <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.75rem">{{ formatPrice(item.price) }}</p>
                                                    <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem">{{ formatPrice(item.price - item.price * (item.discount / 100)) }}</v-list-item-subtitle>
                                                </div>
                                            </v-list-item-content>
                                        </template>

                                        <template v-else-if="item.value">
                                            <v-list-item-content class="py-0">
                                                <div class="flex-column" style="line-height: 18px">
                                                    <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.75em">{{ formatPrice(item.price) }}</p>
                                                    <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.75rem">{{ formatPrice(item.value) }}</v-list-item-subtitle>
                                                </div>
                                            </v-list-item-content>
                                        </template>

                                        <template v-else>
                                            {{ formatPrice(item.price) }}
                                        </template>
                                    </div>
                                    <div class="btn-actions">
                                        <div class="mr-1 myprovet-cart-item-button">
                                            <v-tooltip v-if="index == 0 && isActiveCampaign" bottom open-on-hover content-class="myprovet-tooltip">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color" @click="forceRemoveCampaign(item)" v-on="on" v-bind="attrs" data-cy="remove-product"> mdi-delete-outline </v-icon>
                                                </template>

                                                <span>{{ $t('cart.removeCampaign') }}</span>
                                            </v-tooltip>
                                        </div>
                                        <div class="mr-1 myprovet-cart-item-button">
                                            <product-comment v-if="item.quantity > 0" :product="item"></product-comment>
                                        </div>

                                    </div>
                                    <!--<v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon style="" :color="isAvailable(product) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                    </template>

                                                                    <span>{{ isAvailable(product) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                                                </v-tooltip>
                                                                <product-additional-info :product="product"> </product-additional-info>-->
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                            <v-row :class="hideQuantityCounter(item) ?'d-flex align-start pt-0 pb-0 no-label-qty':'d-flex align-start pt-0 pb-0 no-input-bonus'">
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-0 label" v-if="!hideQuantityCounter(item) ">{{ $t('orders.base.quantity') }}</div>
                                    <quantity-counter v-if="!item.isOffer"
                                        :is-active-campaign="isActiveCampaign"
                                        :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        @input="onCampaignQuantityUpdated(item, $event)"
                                        @input-remove-campaign="tryRemoveCampaign(item)"
                                        @increment="changeCampaignQuantity(item, true)"
                                        @decrement="changeCampaignQuantity(item, false)"
                                        :hide-input="hideQuantityCounter(item)"
                                        :hide-counter="hideQuantityCounter(item) || branchStore.cannotPurchase"
                                        :disabled="item.exceeding_quantity || branchStore.cannotPurchase? true : false"
                                        class="justify-space-between mx-auto"
                                        input-class="shopping-cart-input minimum-input-size">
                                    </quantity-counter>
                                    <quantity-counter v-else-if="item.isOffer && item.exceeding_quantity"
                                        :is-active-campaign="isActiveCampaign" :value="item.quantity"
                                        :min="item.min_quantity"
                                        :max="maxQuantityCampaign(item.max_quantity)"
                                        :disabled="true"
                                        :hide-counter="true"
                                        input-class="shopping-cart-input minimum-input-size">
                                   </quantity-counter>
                                </v-col>
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-2 empty"></div>
                                    <div class="col pt-0 pb-2  pl-0 pr-0 label lf">
                                        <div class="l-sub">{{ $t('orders.base.vat') }}</div>
                                        <div class="l-sub-value">{{item.vat.tax}} %</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="col col-12 pt-0 pb-0">
                            <v-row :class="hideQuantityCounter(item) ?'d-flex align-start pt-0 pb-0 no-input-qty':'d-flex align-start pt-0 pb-0 no-label-bn'">
                                <v-col class="col col-6 pt-0 pb-0 pl-0 wrap-bonus">
                                    <div class="col pt-0 pb-0 label" v-if="hideQuantityCounter(item)">{{ $t('orders.base.bonus') }}</div>
                                    <p v-if="isBonusDiscount(item)" class="shopping-cart-product-title mt-5" data-cy="cart-item-discount-percentage">{{ item.discount }}%</p>
                                    <quantity-counter v-else :readonly="item.campaign_id != null || !canChangeBonusQuantity"
                                    :hide-counter="item.campaign_id != null || !canChangeBonusQuantity || branchStore.cannotPurchase"
                                    :hide-input="!hideQuantityCounter(item) || branchStore.cannotPurchase"
                                    :value="offerBonusQuantity(item,index)"
                                    :min="item.quantity > 0 ? 0 : 1"
                                    input-class="shopping-cart-input minimum-input-size">
                                </quantity-counter>
                                </v-col>
                                <v-col class="col col-6 pt-0 pb-0 pl-0">
                                    <div class="col pt-0 pb-2 empty"></div>
                                    <div class="col pt-0 pb-2  pl-0 pr-0 label lf ">
                                        <div class="l-sub">{{ $t('campaigns.value') }}</div>
                                        <div class="l-sub-value" v-if="userStore.hasPermissionTo('View prices')">

                                            <p class="shopping-cart-product-title " data-cy="cart-item-sub-total-price">{{ formatPrice(getProductSubTotalPrice(item)) }}</p>

                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>
                </v-col>
            </v-row>
    </div>
    <div class="text-center" v-if="totalItems>5 && !isToShowOnlyOneProductCampaign">
                <v-pagination
                v-model="currentPage"
                :length="numberPages"
                :total-visible="7"
                ></v-pagination>
    </div>
</div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';

export default {
    props: {
        campaign: Object,
        product: Object,
        currentSearchTerm: String,
    },

    data: () => ({
        comment: null,
        searchArticle:'',
        selectedProduct: {},
        selectedOption: null,
        requirementsWithMatchingPrice: [],
        quantityCounterKey: 0,
        timer: null,
        totalItems:0,
        currentPage:1,
        currentPageSize:5,
        showSelected:false,
        isDisabledSelected:true,
        numberPages:1,
        tempOffers:[],
        isNormalOrder:false,
        isSimposium:false,
        isExpressOrder:false,
        isToShowOnlyOneProductCampaign:false
    }),

    computed: {
        ...mapStores(useBranchStore, useNormalOrderStore, useUserStore,useAppStore),

        getCampaignItems() {
            let self=this
            if (!this.campaign) return;

            // @Note: We're only going to display all requirement products for this campaign.
            const requirements = this.campaign.requirements || [];
            const offers = this.campaign.offers || [];
            const levels = this.campaign.levels || [];
            const requirementProducts = [];
            let display = [];

            if(this.isNormalOrder || this.isSimposium || this.isExpressOrder){
                if(this.campaign.amount_of_requirements_needed <= 1 && this.campaign.minimum_value_necessary_quantity == 0){
                    this.isToShowOnlyOneProductCampaign = true
                }else{
                    this.isToShowOnlyOneProductCampaign = false
                }
            }else{
                this.isToShowOnlyOneProductCampaign = false
            }
            // Case 1) There's only one requirement => we'll display the campaign with the offers in an indented line.
            // Case 2) There's more than one requirement => we'll display the offers in separate lines.
            const isSeparate = requirements.length !== 1;
            const displayedRequirementIds = new Set(); // To avoid duplicates

            for (const requirement of requirements) {
                const product = requirement.product;
                if (!product) continue;

                product.isHeader = true;
                product.isSeparate = isSeparate;
                product.levels = levels

                displayedRequirementIds.add(product.id);

                // Special condition for requirement with exceeding quantity
                if (product.exceeding_quantity) {
                    const discount = product.discount;
                    const quantityWithoutDiscount = product.min_quantity;
                    let quantityWithDiscount = product.quantity == 0 ? 0 : product.quantity - product.min_quantity;

                    // Set the total quantity that will be used when the user increments or decrements the product with exceeding quantity
                    product.totalQuantity = quantityWithoutDiscount + quantityWithDiscount;

                    if (product.max_quantity && product.quantity > product.max_quantity) {
                        quantityWithDiscount = quantityWithDiscount - (product.quantity - product.max_quantity);
                    }

                    // Push the product without discount
                    const productWithoutDiscount = { ...product };
                    productWithoutDiscount.quantity = quantityWithoutDiscount;
                    productWithoutDiscount.discount = 0;
                    productWithoutDiscount.value = 0;
                    //display.push(productWithoutDiscount);
                    requirementProducts.push(productWithoutDiscount);

                    // Push the product with discount
                    const productWithDiscount = { ...product };
                    productWithDiscount.quantity = quantityWithDiscount;
                    productWithDiscount.discount = discount;
                    productWithDiscount.isOffer = true;
                    productWithDiscount.uniqueId = productWithDiscount.uniqueId.replace('header', 'offer');
                    //display.push(productWithDiscount);
                    requirementProducts.push(productWithoutDiscount);
                } else {
                    //display.push(requirement.product);
                    requirementProducts.push(product);
                }
            }

            // Add requirements with quantity === 0 that are not already displayed
            const baseCampaign = this.normalOrderStore.getBaseCampaignByUniqueId?.(this.campaign.unique_id);

            if (baseCampaign && Array.isArray(baseCampaign.requirements) && !baseCampaign.split_promotion) {
                for (const requirement of baseCampaign.requirements) {
                    const product = requirement?.product;
                    if (!product) continue;

                    const isMissingAndZero = product.quantity === 0 && !displayedRequirementIds.has(product.id);
                    if (isMissingAndZero) {
                        product.isHeader = true;
                        product.isSeparate = isSeparate;
                        requirementProducts.push(product);
                        displayedRequirementIds.add(product.id);
                    }
                }
            }
            //requirementProducts.sort((a, b) => a.id - b.id);
            display.push(...requirementProducts);

            for (const offer of offers) {
                offer.product.isSeparate = isSeparate;

                // @Note: Set the option property into the product object
                offer.product.option = offer.option;

                if (offer.product) {
                    display.push(offer.product);
                }
            }
            this.totalItems = _.size(display)
            if(this.totalItems >5 && !this.isToShowOnlyOneProductCampaign)
               this.tempOffers = _.cloneDeep(_.filter(display,{isOffer:true}))

            this.isDisabledSelected =_.size(_.filter(display,(o)=>{return o.quantity>0 }))?false:true;
            if(this.isDisabledSelected && !this.campaign.in_shopping_cart){
                if(this.showSelected){
                    this.showSelected=false
                }
            }else{
                if(_.has(this.campaign,'in_shopping_cart')){
                    this.isDisabledSelected = true
                    this.showSelected=true
                }
            }

            if(this.showSelected){
                display = _.filter(display,(o)=>{return o.quantity>0 && !o.isOffer || o.isOffer})
            }

            let fdata = display.filter(item => {
                function valStr(string) {
                    string = string + ''
                    string = string.replace(/ /g, '')
                    let strq = self.searchArticle
                    strq = strq.replace(/ /g, '')
                    let terms = _.split(strq,'%')
                    if(_.size(terms)>1){
                        return terms.every(term => string.toLowerCase().includes(term))
                    }else{
                        return string.toLowerCase().indexOf(strq.toLowerCase()) > -1
                    }
                }
                //Object.values(item.name).find(valStr)
                var result = _.size(this.searchArticle)>0 ? valStr(item.designation) || valStr(item.code) || valStr(item.ean) :display;
                return result != undefined && result != false
            })

            let total=0
            if(this.totalItems>5 && !this.isToShowOnlyOneProductCampaign){
               _.each(fdata,(o)=>{
                  if(!o.isOffer){
                    total++
                  }
               })
            }else{
                total= _.size(fdata)
            }
            if(!this.isToShowOnlyOneProductCampaign){
                //this.total= fdata.length
                let offset = ((this.currentPage||1) - 1) * this.currentPageSize
                let limit= this.currentPageSize //(this.currentPage +1 ) * this.currentPageSize
                //console.log('offset',offset,limit,this.totalItems,total,display)
                fdata = fdata.slice(offset).slice(0,limit)
                this.numberPages = Math.ceil(total / this.currentPageSize)
            }
            return fdata;
        },

        canChangeBonusQuantity() {
            return this.userStore.hasPermissionTo('Change bonus quantity (as propec)') || this.userStore.hasPermissionTo('Change bonus quantity (as supplier)');
        },

        isActiveCampaign() {
            return this.normalOrderStore.isActiveCampaignByUniqueId(this.campaign.unique_id);
        },

        selectedOffer() {
            return this.selectedOption ?? this.campaign.offers.at(0)?.selectedOption;
        },
        hasMultipleOptions() {
            if (this.campaign.offers.length === 0) {
                return false;
            }

            // If the first offer's option is different than any other, we can choose from multiple offers.
            const firstOffer = this.campaign.offers[0];

            return this.campaign.offers.some((it) => it.option !== firstOffer.option);
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
    },
    mounted(){
        this.isNormalOrder = window.location.href.indexOf('orders/normal') !=-1 ? true : false
        this.isSimposium = window.location.href.indexOf('products/simposium') !=-1 ? true : false
        this.isExpressOrder = window.location.href.indexOf('orders/express') !=-1 ? true : false
    },
    methods: {
        checkIfToShowAllProducts(item){
            if(this.isToShowOnlyOneProductCampaign){
                return item.code == this.product.code || item.quantity > 0? true : false
            }
            return this.totalItems <= 5 || this.totalItems>5 && !item.isOffer
        },
        updateCurrentPage(){
            this.currentPage = 1
        },
        calculateHeaderColWidth(field) {
            switch (field) {
                case 'designation':
                    if (!this.userStore.hasPermissionTo('View prices')) {
                        return this.calculateColWidth(field);
                    }

                    return 'width: 38%; max-width: 38%';
                default:
                    return this.calculateColWidth(field);
            }
        },

        calculateColWidth(field) {
            switch (field) {
                case 'designation':
                    if (!this.userStore.hasPermissionTo('View prices')) {
                        return 'width: 52%; max-width: 52%';
                    }

                    return 'width: 38%; max-width: 38%';

                case 'quantity':
                case 'bonus':
                    return 'width: 15%; max-width: 15%';

                case 'price':
                case 'tax':
                case 'total':
                    return 'width: 8%; max-width: 8%';

                case 'actions':
                    return 'width: 8%; max-width: 8%';

                default:
                    return '';
            }
        },

        isBonusDiscount(product) {
            return product.discount && product.discount > 0 && product.discount != 100;
        },

        hasProductsToShow() {
            return false;
        },

        hideQuantityCounter(product) {
            if (product.isHeader) return false;
            if (product.exceeding_quantity && product.isOffer) return false;
            if (product.isOffer) return true;
        },

        offerBonusQuantity(product,index) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            let hasQuantity=false
            //console.log('offerBonusQuantity',this.getCampaignItems,product.isOffer,index,product.code);
            if(this.campaign.minimum_value_necessary_quantity>0){
                let total=0
                _.each(this.getCampaignItems,(o)=>{
                     if(!o.isOffer){
                        total=total+o.quantity
                     }
                })
                if(total >= this.campaign.minimum_value_necessary_quantity){
                    return product.isOffer ? product.quantity : 0
                }
            }else{

                if(_.size(this.getCampaignItems)==2 && product.isOffer){
                        if(index>0)
                            return this.getCampaignItems[index-1].quantity > 0?product.quantity :0
                }else{
                     _.each(this.getCampaignItems,(o)=>{
                        if(!o.isOffer){
                            if(o.quantity>0){
                                hasQuantity=true
                            }
                        }
                    })
                }
            }
            return product.isOffer ? hasQuantity || this.tempOffers.length>0 ? product.quantity : 0 : 0;
        },
        getProductSubTotalPrice(item) {
            const withDiscount = this.normalOrderStore.calculatePriceWithDiscount(item);
            const withoutDiscount = item.price;

            return this.normalOrderStore.calculateWithExceedingQuantity(item, withDiscount, withoutDiscount);
        },

        updateRequirementsWithMatchingPrice() {
            if (!this.campaign.has_minimum_value_offer) {
                return false;
            }

            const getPriceForCampaignItem = (item) => this.normalOrderStore.calculatePriceWithDiscount(item.product);

            const cheaperProducts = [...this.campaign.requirements]
                .filter((r) => r.product.quantity) //
                .sort((a, b) => getPriceForCampaignItem(a) - getPriceForCampaignItem(b));

            const matchingPrices = cheaperProducts.length >= 2 && getPriceForCampaignItem(cheaperProducts[0]) === getPriceForCampaignItem(cheaperProducts[1]);
            const noneSelected = cheaperProducts.length >= 2 && !cheaperProducts[0].isCheaperSelected && !cheaperProducts[1].isCheaperSelected;

            this.requirementsWithMatchingPrice =
                matchingPrices && noneSelected //
                    ? _.filter(cheaperProducts, p => p.product.price === cheaperProducts[0].product.price)//.slice(0, 2)
                    : [];

            return this.requirementsWithMatchingPrice.length;
        },

        onCampaignQuantityUpdated(product, amount) {
            const requirement = this.campaign.requirements.find((it) => it.product.index === product.index);

            // Debounce the search - it will prevent errors when updating too quickly.
            clearTimeout(this.timer);

            this.timer = setTimeout(() => {
                const quantityDiff = Math.abs(requirement.product.quantity - amount);
                const currentRequirementsQuantity =
                    amount > requirement.product.quantity //
                        ? this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0) + quantityDiff
                        : this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0) - quantityDiff;

                // If the user has inputted a value in an active campaign product, that makes the campaign invalid
                if (this.campaign.minimum_value_necessary_quantity > 0 && currentRequirementsQuantity < this.campaign.minimum_value_necessary_quantity) {
                    this.quantityCounterKey += 1;
                    this.tryRemoveCampaign(product);
                    return;
                }

                product.quantity = this.parseQuantity(amount, true);
                this.changeCampaignQuantity(product);
            }, 700);
        },
        getApplicableLevel(levels,quantity) {
            if (!levels || !quantity) return null;
            // Ordena os níveis por min_quantity descrescente para apanhar o maior nível aplicável
            const sortedLevels = _.orderBy(levels, ['min_quantity'], ['desc']);
            //console.log('sortedLevels',sortedLevels,quantity);
            // Encontra o primeiro nível onde a quantity >= min_quantity
            const applicableLevel = _.find(sortedLevels, level => {
            const meetsMin = quantity >= level.min_quantity;
            const meetsMax = _.isNull(level.max_quantity) || quantity <= level.max_quantity;
            return meetsMin && meetsMax;;
                //if(!_.isNull(level.max_quantity)){
                   // const meetsMax = _.isNull(level.max_quantity) || quantity <= level.max_quantity;
                   // return meetsMin && meetsMax;
                //}
               // return meetsMin && meetsMax;;
            });
            //console.log('applicableLevel', applicableLevel);
            return applicableLevel || null;
        },
        changeCampaignQuantity(product, isIncrement = null) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.setSelectedCampaign();
            this.selectedProduct = product;
            const requirement = this.getSelectedRequirement(product);
            let quantity = product.quantity;

            if(product.levels.length>0){
                // isIncrement === null: typed input, quantity already updated in the requirements, no +/- 1 offset.
                const currentTotal = this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0);
                const totalReqQuantity = isIncrement === null ? currentTotal : (isIncrement ? currentTotal + 1 : currentTotal - 1);
                let level = this.getApplicableLevel(product.levels,totalReqQuantity)
                if(level){
                    _.each(this.campaign.requirements,(req)=>{
                        req.discount = level.discount
                        req.product.discount = level.discount
                        req.originating_product.discount = level.discount
                    })
                }
            }

            if (product.exceeding_quantity) {
                if (product.totalQuantity > product.min_quantity) {
                    isIncrement //
                        ? product.totalQuantity + product.quantity
                        : product.totalQuantity - product.quantity;
                }

                quantity = product.totalQuantity;
            }

            const minimumValueMinQuantity = this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0) - 1;
            const currentAmountOfRequirementsNeeded = this.campaign.requirements.filter(function (requirement) {
                return requirement.product.id == product.id ? requirement.product.quantity - product.min_quantity > 0 : requirement.product.quantity > 0;
            }).length;

            if (
                this.isActiveCampaign &&
                isIncrement == false &&
                (currentAmountOfRequirementsNeeded < this.campaign.amount_of_requirements_needed || quantity <= product.min_quantity || minimumValueMinQuantity < this.campaign.minimum_value_necessary_quantity || (requirement.exceeding_quantity && minimumValueMinQuantity <= requirement.min_quantity))
            ) {
                this.tryRemoveCampaign(product, isIncrement);
                return;
            }

            const checkForRequirementsWithMatchingPrice = () => {
                if (this.updateRequirementsWithMatchingPrice()) {
                    this.$emit('open-matching-price-dialog', this.requirementsWithMatchingPrice);
                }
            };
            if (this.isActiveCampaign) {
                this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement, this.currentSearchTerm);
                return checkForRequirementsWithMatchingPrice();
            }

            this.normalOrderStore.changeCampaignQuantity(this.campaign, this.campaign.requirements, this.campaign.offers, false, { requirement, isIncrement, exists: false }, this.currentSearchTerm);
            checkForRequirementsWithMatchingPrice();
        },
        getSelectedRequirement(product) {
            let requirement = this.campaign.requirements.find((requirement) => {
                return requirement.product.isHeader && requirement.product.campaign_id == product.campaign_id && requirement.product.id == product.id;
            });
            if (requirement.product.quantity === 0) requirement.product.quantity = product.quantity;
            return requirement;
        },

        maxQuantityCampaign(max_quantity) {
            return max_quantity > 0 ? max_quantity : 9999999;
        },

        selectOffer(product) {
            this.setSelectedCampaign();
            this.selectedProduct = product;
            this.selectedOption = product.option;

            for (const offer of this.campaign.offers) {
                this.$set(offer, 'selectedOption', this.selectedOption);
                this.$set(offer.product, 'selectedOption', this.selectedOption);
            }

            this.setSelectedOfferOption();
        },

        setSelectedProduct() {
            this.$emit('selected-product', this.selectedProduct);
        },

        setSelectedCampaign() {
            this.$emit('selected-campaign', this.campaign);
        },

        setSelectedOfferOption() {
            this.setSelectedCampaign();
            this.setSelectedProduct();
            this.$emit('selected-option', this.selectedOption);
        },

        openProductDetails(product) {
            this.selectedProduct = product;
            this.setSelectedProduct();
            this.$emit('open-product-details', product);
        },

        tryRemoveCampaign(product, isIncrement = null) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.selectedProduct = product;

            this.setSelectedCampaign();
            this.setSelectedProduct();

            this.$emit('input-remove-campaign', { campaign: this.campaign, product: product, isIncrement: isIncrement });
        },
    },
};
</script>
